/* eslint-disable camelcase */
import { Vue, Component } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import { FrontGlobalParametersDetailResponse } from '@/api/resources/common/initialization/common-initialization.dto'
import { StoreUtils } from '@/shared/util/store-utils'

@Component
export class StoreMixin extends Vue {
    get $_globalParameters(): Nullable<FrontGlobalParametersDetailResponse> {
        return StoreUtils.globalParameters
    }

    $_getModalConfirmationState(modalStateName: string, modalName: string): any | null {
        return StoreUtils.getModalConfirmationState(modalStateName, modalName)
    }
    async $_setModalConfirmationState(name: string, state: any): Promise<void> {
        await StoreUtils.setModalConfirmationState(name, state)
    }

    $_cleanSearchState(): void {
        StoreUtils.cleanSearchState()
    }

    $_updateLoading(state: boolean): void {
        StoreUtils.updateLoading(state)
    }
}
